import React, { useState } from 'react';
import { TableCell, TableRow, Checkbox, Input, } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import * as actions2 from '../../../../reducers/form';
import { editFieldTable } from '../../../../reducers/formTable';
import { createSelector } from 'reselect';


const selectSelectId = (state, formName) =>
  state.form[formName]?.values?.selectId || [];

export const selectIsItemSelected = createSelector(
  [selectSelectId, (state, formName, row) => row],
  (selectId, row) => selectId.indexOf(row) !== -1
);

export default function TableRowMaterial({ multiSelect, formName, selectMulti, row, index, column, columnStorage, columnCount }) {
  const obj = useSelector(store => store.formTable[formName]?.byId[row])
  const isItemSelected = useSelector((state) => selectIsItemSelected(state, formName, row));
  const dispatch = useDispatch()
  const handleSelect = () => {
    const checked = !isItemSelected
    if (multiSelect) {
      selectMulti(index, checked)
      return;
    }
    if (checked) {
      dispatch(actions2.formArrayAdd(row, { field: 'selectId', name: formName }))
      return;
    }
    dispatch(actions2.formArrayDelete(row, { field: 'selectId', name: formName }))
  }
  const getRowStyle = () => {
    const shouldHighlight = columnStorage && columnCount && !obj[columnStorage] && !obj[columnCount];
    if (isItemSelected && (!obj[columnCount] || !obj[columnStorage])) {
      return {
        backgroundColor: 'rgba(244, 67, 54, 0.15)',
        '&:hover': { backgroundColor: 'rgba(244, 67, 54, 0.25)' }
      };
    }
    if (!isItemSelected && !!shouldHighlight) {
      return {
        backgroundColor: 'rgba(158, 158, 158, 0.12)',
        '&:hover': { backgroundColor: 'rgba(158, 158, 158, 0.2)' }
      };
    }
    if (isItemSelected) {
      return {
        backgroundColor: 'rgba(25, 118, 210, 0.08)',
        '&:hover': { backgroundColor: 'rgba(25, 118, 210, 0.12)' }
      };
    }
    return {};
  };
  return (
    <TableRow
      key={row}
      sx={getRowStyle()}
    >
      <TableCell padding="checkbox">
        <Checkbox
          id={'checkbox' + row}
          checked={isItemSelected}
          onClick={handleSelect}
        />
      </TableCell>
      {column.map(key => <TableCellNew key={key} row={row} coll={key} value={obj[key]} formName={formName} />)}
    </TableRow>
  )
}

const TableCellNew = React.memo(function TableCellNew({ row, coll, value, formName }) {
  const [edit, setEdit] = useState(false)
  const [editText, setEditText] = useState('')
  const dispatch = useDispatch()
  const handleOk = () => {
    if (value !== editText) {
      dispatch(editFieldTable(editText, { field: coll, id: row, name: formName }))
    }
    setEdit(false)
  }
  const onClick = () => { if (edit) return; setEdit(true); setEditText(value || '') }
  return <TableCell
    padding='none'
    onClick={onClick}
  >
    {(edit) ?
      <Input
        id={'input_' + row + '_' + coll}
        value={editText}
        onChange={(e => setEditText(e.target.value))}
        name='edit'
        multiline
        onBlur={handleOk}
        autoFocus
        fullWidth
        style={{ fontSize: '0.875rem' }}
      />
      : <>{value}</>
    }
  </TableCell>
})